import "./styles.css";
import * as helpTrans from "./help-translations";
import * as settingsTrans from "./settings-translations";
import { bindNavLinks, initApp, localize, mergeTranslations } from "./utils";

const appId = initApp();

$(function () {
  const storeData = EcwidApp.getPayload();

  bindNavLinks();

  const language = storeData.lang;
  const allTrans = mergeTranslations(settingsTrans, helpTrans);
  const trans = allTrans[language] || allTrans["en"];
  localize(trans);

  const qas = trans.qa.map(({ q, a }) => `<div class="form-area__title">${q}</div><div class="form-area__content"><p>${a}</p></div>`);
  $('#qas').html(qas.join(''))
});
